<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
			:showCreateBtn="false"
			:showDeleteBtn="false"
			:navigableDetail="false"
			readOnly
		></pui-datatable>
		<vsincronizacionauditoria-modals :modelName="modelName"></vsincronizacionauditoria-modals>
	</div>
</template>

<script>
import vsincronizacionauditoriaActions from './VSincronizacionauditoriaActions';
import vsincronizacionauditoriaModals from './VSincronizacionauditoriaModals.vue';

export default {
	name: 'vsincronizacionauditoria-grid',
	components: {
		'vsincronizacionauditoria-modals': vsincronizacionauditoriaModals
	},
	data() {
		return {
			modelName: 'sincronizacionauditoria',
			actions: vsincronizacionauditoriaActions.gridactions,
			modelColumnDefs: {
				enviadosmart: {
					render: (data) => {
						if (data == 1) {
							return this.returnYes;
						} else {
							return this.returnNo;
						}
					}
				}
			}
		};
	},
	computed: {
		returnYes() {
			return this.$t('yes');
		},
		returnNo() {
			return this.$t('no');
		}
	}
};
</script>
